// extracted by mini-css-extract-plugin
export default {"container":"header_container__2H93P","statusTag":"header_statusTag__FxcS8"};